




import { Component, Vue } from 'vue-property-decorator';
import LocaleService from "../services/LocaleService";
import Content from "../services/ContentService";
import {VideoMarkers, VideoMarkerType} from "../services/GameLogic";
import {TutorialTipPosition} from "../store/store";

@Component({
    data: function () {
        return {
            timerIDs: [],
            videoMessage: '',
        }
    },
    mounted() {
        let videoUrl:string = this.$store.getters.currentIntroVideo;
        videoUrl = videoUrl.replace(/^\w\w_\w\w\/video\//, ''); // remove nl_NL/video/ at the start
        let entries:VideoMarkers[] = Content.videoMarkers.items;
        let messageDiv:HTMLElement = <HTMLElement> this.$refs.message;
        //console.log('[video-markers] searching markers for', videoUrl);
        for(let entry of entries) {
            if( entry.files.indexOf(videoUrl) >= 0) {
                //console.log('[video-markers] found', entry.markers.length, 'markers for', videoUrl);
                for( let marker of entry.markers) {
                    let timerID = setTimeout(() => {
                        //console.log('[video-markers] timer', timerID, 'fired at', marker.time);
                        switch(marker.type) {
                            case VideoMarkerType.Message: {
                                this.$data.videoMessage = LocaleService.getValue(this.$store.state, marker.param);
                                messageDiv.classList.remove('fadein');
                                messageDiv.classList.remove('fadeout');
                                messageDiv.classList.add('fadein');
                                this.$data.timerIDs.push(
                                    setTimeout(() => {
                                        //console.log('[video-markers] timer', timerID, 'completed');
                                        messageDiv.classList.remove('fadein');
                                        messageDiv.classList.add('fadeout');
                                    }, 4000)
                                );
                            } break;

                            case VideoMarkerType.Tip: {
                                this.$store.commit('showTip', { key: marker.param, position: TutorialTipPosition.center });
                            } break;
                        }
                    }, 1000 * marker.time);
                    //console.log('[video-markers] scheduled', timerID, 'at', marker.time);
                    this.$data.timerIDs.push(timerID);
                }
            }
        }
    },
    destroyed() {
        //console.log('VideoCaptions.destroyed');
        for(let timerID of this.$data.timerIDs) {
            clearTimeout(timerID);
        }
    }
})
export default class VideoCaptions extends Vue {
    showOverlay: boolean = false;
}
